import React from 'react';
import './CookieDeclaration.css';
import { useLanguageContext } from '../../core/locale/LanguageContext';
import { Locale } from '../../core/locale/types';
import vippsMobilepaylogos from './vipps_mobilepay_logos.svg';
import vippsMobilepaylogosDark from './vipps_mobilepay_logos_dark.svg';

function getCookieDeclarationUrl(locale: Locale): string {
  const localeToPathMap: Record<Locale, string> = {
    [Locale.NO]: 'nb-NO',
    [Locale.EN]: 'en-NO',
    [Locale.FI]: 'fi-FI',
    [Locale.DK]: 'da-DK',
  };

  const path = localeToPathMap[locale] || 'en-NO';
  return `https://vippsmobilepay.com/${path}/cookie-info-for-anonymous-id`;
}

function CookieDeclaration(): React.ReactNode {
  const languageContext = useLanguageContext();

  const linkText = languageContext.getLocalizedText('cookieDeclarationLink');
  const cookieDeclarationText = languageContext.getLocalizedText('cookieDeclaration');
  const linkUrl = getCookieDeclarationUrl(languageContext.locale);

  // Replace {cookieDeclaration} placeholder with a hyperlink
  const parts = linkText.split('{cookieDeclaration}');
  const beforeLink = parts[0];
  const afterLink = parts[1] || '';

  return (
    <div className="cookie-declaration">
      <div className="cookie-declaration-icon-wrapper">
        <img
          src={vippsMobilepaylogos}
          alt="Vipps MobilePay"
          className="cookie-declaration-icon cookie-declaration-icon-light"
        />
        <img
          src={vippsMobilepaylogosDark}
          alt="Vipps MobilePay"
          className="cookie-declaration-icon cookie-declaration-icon-dark"
        />
      </div>
      <p className="cookie-declaration-paragraph">
        <span className="cookie-declaration-text-content">
          {languageContext.getLocalizedText('cookieDeclarationText')}
        </span>
        &nbsp;
        <span className="cookie-declaration-text-content">{beforeLink}</span>
        <a
          href={linkUrl}
          className="cookie-declaration-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {cookieDeclarationText}
        </a>
        {afterLink}
      </p>
    </div>
  );
}

export default CookieDeclaration;
